import {Component, Input} from '@angular/core';
import {NbButtonModule, NbCardModule, NbDialogRef} from '@nebular/theme';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  imports: [
    NbCardModule,
    NbButtonModule
  ]
})
export class ConfirmDialogComponent {

  @Input() description: string;
  /** Статус (цвет) кнопки подтверждения. По умолчанию `primary`; `danger` — для
   *  деструктивных действий (удаление/очистка) → красная кнопка. */
  @Input() confirmStatus = 'primary';

  constructor(protected ref: NbDialogRef<ConfirmDialogComponent>) {
  }

  dismiss(confirmed: boolean) {
    this.ref.close(confirmed);
  }

}
